import React from 'react'
import { withFirebase } from '../../components/Fb'

// reactstrap components
import {
  Row,
  Col
} from 'reactstrap'
import Coloring from '../../components/Config/Coloring'

// core components

class ConfigColorsContainer extends React.Component {
  render () {
    return (
      <>
        <div className='content'>
          <Row>
            <Col md='12'>
              <Coloring { ...this.props } />
            </Col>
          </Row>
        </div>
      </>
    )
  }
}

export default withFirebase(ConfigColorsContainer)
